<div class="gold-upgrade-left">
  <app-icon [icon]="'aha-gold-upgrade-prompt-left-panel'"></app-icon>
  <p
    class="upgrade-description"
    [style]="'fontSize.23' | translate"
    [innerHTML]="'streaming.plan.info' | translate"
  ></p>
</div>
